import React from 'react';
import { styled } from '@mui/material';
import { InfoCard } from 'components';
import { getObjectValue } from 'utilities';
import { DialogHeaderProps } from './types';

const PREFIX = 'DialogHeader';

const classes = {
  infoCards: `${PREFIX}-infoCards`,
};

const Root = styled('div')(() => ({
  [`&.${classes.infoCards}`]: {
    display: 'flex',
    padding: '1rem 2.5rem',
    backgroundColor: '#f1f4f6',

    '& .MuiPaper-root': {
      flexGrow: 1,
      '&:last-child': {
        marginRight: 0,
      },
    },
  },
}));

const DialogHeader = (props: DialogHeaderProps) => {
  const { waccInfo } = getObjectValue(props);

  return (
    <Root className={classes.infoCards}>
      <InfoCard title="WEIGHTED AVERAGE COST OF CAPITAL" body={`${Number(waccInfo ?? 0).toFixed(1)} %`} />
    </Root>
  );
};

export default DialogHeader;
